var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWblogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 35,
    viewBox: "0 0 172 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4209_4625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7602 28.7827L17.5701 13.1558L13.3132 28.7827H7.38279L0.00708008 6.18219H6.13243L10.5491 22.8098L14.8691 6.18219H20.4782L24.8948 22.8098L29.2465 6.18219H35.1137L27.6678 28.7827H21.7602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8756 10.7023V15.1907H53.6424V19.7108H42.8756V24.2714H55.1579V28.7915H37.1366V6.18219H54.8032V10.7023H42.8756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1784 23.9724V28.7827H58.8651V6.18219H64.6041V23.9724H74.1784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2317 23.9724V28.7827H76.9184V6.18219H82.6574V23.9724H92.2317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.869 0H99.2669C97.5376 0 96.1357 1.404 96.1357 3.13593V31.8641C96.1357 33.596 97.5376 35 99.2669 35H168.869C170.598 35 172 33.596 172 31.8641V3.13593C172 1.404 170.598 0 168.869 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.757 6.18219C119.82 6.18219 123.043 8.37716 123.043 11.8314C123.043 14.2216 121.561 16.1264 119.179 16.8035C122.015 17.3541 123.821 19.5807 123.821 22.5196C123.821 26.3608 120.468 28.7827 115.149 28.7827H104.085V6.18219H114.757ZM109.793 15.2224H114.436C116.111 15.2224 117.176 14.3184 117.176 12.8656C117.176 11.4128 116.111 10.5792 114.436 10.5792H109.793V15.2224ZM109.793 24.3593H114.436C116.564 24.3593 117.885 23.4236 117.885 21.8091C117.885 20.2912 116.564 19.3556 114.436 19.3556H109.793V24.3593Z",
    fill: "#3376A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.875 10.7023V15.1907H143.644V19.7108H132.875V24.2714H145.158V28.7915H127.136V6.18219H144.803V10.7023H132.875Z",
    fill: "#3376A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.31 10.799V28.7826H153.573V10.799H146.835V6.15576H166.113V10.799H159.31Z",
    fill: "#3376A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4209_4625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 35,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWblogo);
export default ForwardRef;